<template>

<div class="card-body">
    <div class="row m-0">

        <div v-for='v in videos' :class="['mb-3', getClasses()]">

            <div v-if='v.p == 1' class="video-content" @click='play(v.u)'>
                <span class="video-overway">
                    <span class="icon icon-play-circle"></span>
                </span>
                <img height="100%" :src="v.t" alt="Free Content" class="img-fluid">
            </div>

            <div v-if='v.p == 0' class="premium-content premium-video video-content">
                <span class="premium-tooltip">
                    <h6 class="mb-1">Premium content</h6>
                    <p class="mb-1">Want to see everything?</p>
                    <a :href='planURL()' target="_blank">Get a plan now</a>
                </span>

                <span class="img-thumb">                            
                    <span class="img-premium-icon">
                        <span class="icon icon-lock"></span>
                    </span>
                    <img :src="v.t" alt="Premium Content" class="img-fluid">
                </span>
            </div>

        </div>

        <div v-if='videos.length > 1' :class="['pl-2 pr-2 d-flex justify-content-center col-lg-3 col-sm-4 col-6']">
            <span class="img-thumb w-100 mb-0 pb18">
                <a :href="'/onlyfans-models/' + this.s" class="w-100 d-flex justify-content-center align-items-center flex-column view-model">
                    <span class="img-overway"></span>
                    <span class="icon icon-arrow-right-circle"></span>
                    <span class="text">View more </span>
                    <span class="text hide-on-mob">from this model</span>
                </a>
            </span>
        </div>

    </div>
</div>

</template>

<script>
    export default {

        mounted() {

        },

        props : ['c','i','s'],

        created() {

            if( typeof this.c == 'string' ) {
                this.videos = JSON.parse( this.c );
            } else {
                this.videos = this.c;
            }

        },

        data() {
            return {
                isReady : false,
                id      : 0,
                videos : [],
            }
        },

        methods : {
            getClasses() {
                if ( this.videos.length > 1 ) {
                    return 'col-lg-3 col-sm-4 col-6';
                } else {
                    return 'col-12';
                }
            }
        }

    }
</script>
